export default __webpack_public_path__ + "static/media/ic_angle_down.72794c1c.svg";